
import mmpModal from '~comp/_common/mmp-popup/MmpModal.vue'
import MmpAlertConfirmModal from '~comp/_common/mmp-popup/MmpAlertConfirmModal.vue'
// import MmpToastTemplate from '~comp/_common/mmp-toast/MmpToast.vue'

import { uniqueId, remove } from 'lodash'

const MmpPopupPlugin = {
  install (Vue) {
    Vue.component(mmpModal.name, mmpModal)
    var routerObj = window.vue.getInstance('router')

    var modalObjList = []

    routerObj.beforeEach((to, from, next) => {
      var isBack = Vue.prototype.$isBack(to)
      if (modalObjList.length > 0 && isBack) {
        var modalObj = modalObjList[modalObjList.length - 1].modal
        modalObj.modalCloseed()
        // modalObj.$destroy()
        next(false)
      } else {
        next()
      }
    })

    function removeModal (id) {
      if (id) {
        const afterModalList = remove(modalObjList, {id: id})
        if (afterModalList.length > 0) {
          const targetModal = afterModalList[afterModalList.length - 1]
          // console.log('targetModal.container', targetModal)
          if (targetModal.container) {
            const elDimm = targetModal.container.getElementsByClassName('dimm')
            if (elDimm[0] && elDimm[0].parentNode) elDimm[0].parentNode.removeChild(elDimm[0])
          }
        }
      }
    }

    function _pushModal (modalObj) {
      modalObjList.push(modalObj)
      // console.log('>>modalObjList', modalObjList)
      if (modalObjList.length > 1) {
        var dim = document.createElement('div')
        dim.className = 'dimm'

        var modalDiv = modalObjList[1]
        var containerDiv = modalDiv.container
        let compStyles = window.getComputedStyle(containerDiv)
        let borderRadius = compStyles.getPropertyValue('border-radius')
        // console.log('borderRadius', borderRadius)
        if (borderRadius) {
          dim.style.setProperty('border-radius', borderRadius)
        }

        containerDiv.firstChild.appendChild(dim)
      }
      console.log('modalObjList.length', modalObjList.length)
    }

    Vue.popup = Vue.prototype.$popup = {
      toast (message, options = {}) {
        var defaultOptions = {
          position: 'top-center',
          timeout: 2500,
          closeOnClick: false,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          showCloseButtonOnHover: false,
          closeButton: 'button',
          hideProgressBar: true,
          icon: {
            iconClass: 'popup_chk',
            iconChildren: '',
            iconTag: 'span'
          },
          rtl: false,
          toastClassName: '',
          bodyClassName: '',
          transition: 'Vue-Toastification__fade',
          onMounted: (e) => {
            console.log('onMounted :', e)
          }
        }
        // const contentObj = {
        //   // Your component or JSX template
        //   component: MmpToastTemplate,

        //   // Props are just regular props, but these won't be reactive
        //   props: {
        //     contents: message
        //   }
        // }

        Vue.$toast(message, Object.assign({}, defaultOptions, options))
        // <button class="popup_close" onClick={this.onClick}><span class="blind">닫기</span></button>
        // </div>
      },
      isModalActive () {
        return (modalObjList.length > 0)
      },
      // pushModal (modalObj) {
      //   console.log('>>modalObjList.length', modalObjList.length)
      //   modalObjList.push(modalObj)
      // },
      alert (container, params) {
        return new Promise( function (resolve, reject) {
          var dim = document.createElement('div')
          dim.className = 'dimm'

          var modalId = uniqueId('dynamic_alert_')

          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          var alertProps = Object.assign({}, {isAlert: true}, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(MmpAlertConfirmModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  if (this.$options.dim) {
                    this.$options.rootContainer.appendChild(this.$options.dim)
                  }
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  if (this.$options.dim) {
                    document.body.appendChild(this.$options.dim)
                  }
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  console.log(this, ev, container)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            dim: dim,
            rootContainer: document.body,
            propsData: alertProps
          })

          // modalObjList.push({
          //   id: modalId,
          //   modal: dynamicModal
          // })
          _pushModal({ id: modalId, modal: dynamicModal, container: container })
        })
      },
      confirm (container, params) {
        return new Promise( function (resolve, reject) {
          let scrollLock = true
          var dim = document.createElement('div')
          dim.className = 'dimm'
          var modalId = uniqueId('dynamic_confirm_')

          if (params.scrollLock === false) scrollLock = false

          const defaultAttrs = {
            programmatic: true,
            visible: true,
            scrollLock: scrollLock,
            name: modalId
          }

          var alertProps = Object.assign({}, {isAlert: false}, params)
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(MmpAlertConfirmModal).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.$options.rootContainer) {
                  if (this.$options.dim) {
                    this.$options.rootContainer.appendChild(this.$options.dim)
                  }
                  this.$options.rootContainer.appendChild(this.$el)
                } else {
                  if (this.$options.dim) {
                    document.body.appendChild(this.$options.dim)
                  }
                  document.body.appendChild(this.$el)
                }
              },
              beforeDestroy () {
                if (this.$options.dim) {
                  this.$el.parentNode.removeChild(this.$options.dim)
                }
                this.$el.parentNode.removeChild(this.$el)

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  console.log(ev)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            dim: dim,
            rootContainer: document.body,
            propsData: alertProps
          })

          // modalObjList.push({
          //   id: modalId,
          //   modal: dynamicModal
          // })
          _pushModal({ id: modalId, modal: dynamicModal, container: container })
        })
      },
      // 모바일 전용 하단에서 올라오는 팝업
      bottomSheet (container, modalComponent, params) {
        return new Promise( function (resolve, reject) {
          const dim = document.createElement('div')
          dim.className = 'dimm'

          const modalId = uniqueId('dynamic_bottomsheet_')

          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }

          const Modal = Vue.extend(modalComponent).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
                this.$el.classList.add('active')
              },
              beforeMount () {
                if (this.isValidParam !== undefined && this.isValidParam) {
                  if (this.$options.rootContainer) {
                    if (this.$options.dim) {
                      this.$options.rootContainer.appendChild(this.$options.dim)
                    }
                    this.$options.rootContainer.appendChild(this.$el)
                  } else {
                    if (this.$options.dim) {
                      document.body.appendChild(this.$options.dim)
                    }
                    document.body.appendChild(this.$el)
                  }
                } else {
                  this.modalCloseed()
                }
              },
              beforeDestroy () {
                if (this.isValidParam !== undefined && this.isValidParam) {
                  this.$el.classList.remove('active')
                  if (this.$options.dim) {
                    this.$el.parentNode.removeChild(this.$options.dim)
                  }
                  setTimeout(() => {
                    this.$el.parentNode.removeChild(this.$el)
                  }, 300)
                }

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  console.log(ev)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            dim: dim,
            rootContainer: document.body,
            propsData: params
          })

          modalObjList.push({
            id: modalId,
            modal: dynamicModal
          })
        })
      },
      openModal (container, modalComponent, params) {
        return new Promise( function (resolve, reject) {
          var dim = document.createElement('div')
          dim.className = 'dimm'

          var modalId = uniqueId('dynamic_modal_')

          const defaultAttrs = {
            programmatic: true,
            visible: true,
            name: modalId
          }
          // const propsData = Object.assign(defaultParam, params)

          const Modal = Vue.extend(modalComponent).extend({
            mixins: [{
              mounted () {
                this.$on('close', this.modalCloseed)
              },
              beforeMount () {
                if (this.isValidParam !== undefined && this.isValidParam) {
                  if (this.$options.rootContainer) {
                    if (this.$options.dim) {
                      // dim 클릭시 닫힘 적용
                      if (params.clickDim === true) this.$options.dim.addEventListener('click', this.onClickDim)
                      this.$options.rootContainer.appendChild(this.$options.dim)
                    }
                    this.$options.rootContainer.appendChild(this.$el)
                  } else {
                    if (this.$options.dim) {
                      document.body.appendChild(this.$options.dim)
                    }
                    document.body.appendChild(this.$el)
                  }
                } else {
                  this.modalCloseed()
                }
              },
              beforeDestroy () {
                if (this.isValidParam !== undefined && this.isValidParam) {
                  if (this.$options.dim) {
                    this.$options.dim.removeEventListener('click', this.onClickDim)
                    this.$el.parentNode.removeChild(this.$options.dim)
                  }
                  this.$el.parentNode.removeChild(this.$el)
                }

                removeModal(modalId)
              },
              computed: {
                listeners () {
                  return {
                    ...this.$listeners,
                    'close': this.modalCloseed
                  }
                },
                componentAttrs () {
                  return {
                    ...this.$attrs,
                    ...defaultAttrs
                  }
                }
              },
              methods: {
                modalCloseed (ev) {
                  console.log(ev)
                  resolve(ev)
                  this.$destroy()
                },
                emitClose () {
                  this.$emit('close')
                },
                onClickDim () {
                  this.emitClose()
                }
              }
            }]
          })
          let dynamicModal = new Modal({
            el: document.createElement('div'),
            dim: dim,
            rootContainer: document.body,
            propsData: params
          })

          // modalObjList.push({
          //   id: modalId,
          //   modal: dynamicModal
          // })
          _pushModal({ id: modalId, modal: dynamicModal, container: container })
        })
      }
    }
  }
}

export default MmpPopupPlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpPopup.js